import { createRoute } from "@tanstack/react-router";
import { customerLayoutRoute } from "../../../Dashboard";

export const surveyDashboardRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "survey-dashboard/$dashboardId",
}).lazy(() => import("./SurveyDashboard.lazy").then((d) => d.Route));
